import TextField from "@mui/material/TextField";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import Property from "crqlar-react-common/dist/components/Property";
import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";

interface Props {
    data: UseEntityData<Profile>
    managedExternally?: boolean
}

const CompanyField = (props: Props) => {

    const {t} = useTranslation()
    const profile = props.data.item
    const setProfile = props.data.setItem
    const updateField = (field: keyof Profile, value: any) => {
        setProfile({...profile, [field]: value})
    }

    return (
        <>
            <Property
                title={t('Company Name')}
            >
                <TextField
                    id={'company-name'}
                    size={'small'}
                    value={profile.company?.companyName || ''}
                    onChange={(e) =>
                        updateField('company', {
                            ...profile.company,
                            companyName: e.target.value,
                        })
                    }
                    fullWidth
                    required
                    disabled={props.managedExternally}
                />
            </Property>

            <Property
                title={t('VAT Code')}
            >
                <TextField
                    id={'vat-code'}
                    size={'small'}
                    value={profile.company?.vatCode}
                    onChange={(e) =>
                        updateField('company', {
                            ...profile.company,
                            vatCode: e.target.value,
                        })
                    }
                    fullWidth
                    required
                    disabled={props.managedExternally}
                />
            </Property>
        </>
    )
}

export default CompanyField;
